import { render } from "./StaticPage.vue?vue&type=template&id=3d1ef74f&scoped=true&ts=true"
import script from "./StaticPage.vue?vue&type=script&lang=ts"
export * from "./StaticPage.vue?vue&type=script&lang=ts"

import "./StaticPage.vue?vue&type=style&index=0&id=3d1ef74f&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1ef74f"]])

export default __exports__